import { render, staticRenderFns } from "./unidadMedidaAdd.vue?vue&type=template&id=754dfd1f&"
import script from "./unidadMedidaAdd.vue?vue&type=script&lang=js&"
export * from "./unidadMedidaAdd.vue?vue&type=script&lang=js&"
import style0 from "./unidadMedidaAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports